export default "__VITE_ASSET__qZKRPDW$__"